import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-bandcamp', 'BrandBandcamp', [["path",{"d":"M8.5 6h13.5l-7 12h-13l6.5 -12","key":"svg-0"}]]);